import { render, staticRenderFns } from "./selectGateSlaes.vue?vue&type=template&id=6d324ba3"
import script from "./selectGateSlaes.vue?vue&type=script&lang=js"
export * from "./selectGateSlaes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports